import React, { Component } from 'react';
import { observable, action } from 'mobx';
import { observer, inject } from 'mobx-react';
import { Link, Redirect } from 'react-router-dom';
import { reactLocalStorage as Storage } from 'reactjs-localstorage';
import { getLastPath } from '../../../utils/lastPath';
import moment from 'moment/moment';
import { FormCheckbox, FormGroup } from 'shards-react';
import FeatherIcon from 'feather-icons-react';

import { APPSTORE_URL } from '../../../data/introFeatures';
import app_login_how from '../../../images/app_login_how.png';
import './signIn.scss';

@inject(({ teamUser }) => ({ doSignIn: teamUser.doSignIn, doLogOut: teamUser.doLogOut }))
@observer
class SignIn extends Component {

  @observable teamUser = {
    platformId: '',
    emailId: '',
    password: ''
  };

  @observable lastsignAt;
  @observable isSave = false;
  @observable shouldRedirectToDashboard = false;

  constructor(props) {
    super(props);
    this.init();
  }

  @action
  init = async () => {
    const search = (typeof window !== 'undefined' && window.location && window.location.search) || '';
    const isExplicitLogout = /[?&]logout=1\b/.test(search);

    if (!isExplicitLogout) {
      const existingToken = Storage.get('token');
      const existingRfToken = Storage.get('rfToken');
      if (existingToken && existingRfToken) {
        this.shouldRedirectToDashboard = true;
        return;
      }
    }

    Storage.remove('shops');
    this.lastsignAt = Storage.get('lastsignAt');
    this.props.doLogOut();
    const storageIsSave = await Storage.get('isSave');
    this.isSave = Boolean(storageIsSave);

    if (typeof localStorage !== 'undefined') {
      ['teamUser', 'cafe24Token'].forEach((k) => {
        if (localStorage.getItem(k) === 'undefined') {
          Storage.remove(k);
        }
      });
    }

    let storageTeamUser = {};
    try {
      storageTeamUser = (await Storage.getObject('teamUser')) || {};
    } catch (e) {
      Storage.remove('teamUser');
    }
    this.teamUser.platformId = storageTeamUser.platformId || '';
    this.teamUser.emailId = storageTeamUser.emailId || '';
    this.teamUser.password = storageTeamUser.password || '';
  };

  @action
  doLogin = () => {
    const _this = this;
    const params = {
      platformId: this.teamUser.platformId,
      emailId: this.teamUser.emailId,
      password: this.teamUser.password
    };

    if (_this.isSave) {
      Storage.setObject('teamUser', params);
    } else {
      Storage.remove('teamUser');
    }
    this.props.doSignIn(params, function () {
      _this.props.history.push(getLastPath());   // 최종 이용 페이지로 복원 (없으면 /dashboard)
    });
  };

  onChangeValue = (event) => {
    const { name, value } = event.target;
    this.teamUser[name] = value;
  };

  handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      this.doLogin();
    }
  };

  render() {
    if (this.shouldRedirectToDashboard) {
      return <Redirect to={{ pathname: '/dashboard' }} />;
    }

    const isLocalDev = typeof window !== 'undefined' && window.location && (
      window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1' ||
      window.location.hostname.endsWith('.local')
    );

    const ua = (typeof navigator !== 'undefined' && navigator.userAgent) || '';
    const isMobileUA = /Mobi|Android|iPhone|iPad|iPod|Tablet|Silk|BlackBerry|IEMobile|Opera\s*Mini|webOS/i.test(ua);
    const isIpadDesktopMode = typeof navigator !== 'undefined'
      && navigator.maxTouchPoints > 1
      && /Macintosh/i.test(ua);
    const isPC = !(isMobileUA || isIpadDesktopMode);

    const showSecureGuide = !isLocalDev && isPC
      && (!this.lastsignAt || moment().diff(moment(this.lastsignAt, 'YYYY-MM-DD'), 'days') > 5);

    return (
      <section className="intro-section sign-section">
        <div className="intro-section__inner intro-section__inner--narrow sign-section__inner">

          {showSecureGuide ? (
            <div className="sign-card sign-card--guide">
              <div className="sign-card__head">
                <span className="sign-card__chip">
                  <FeatherIcon icon="shield" size="13" />
                  보안 로그인
                </span>
                <h1 className="sign-card__title">카페24 앱에서 자동 로그인</h1>
                <p className="sign-card__desc">
                  카페24 관리자 페이지에서<br />
                  <strong>[앱 &gt; 마이 앱 &gt; "온리플" 관리하기]</strong> 버튼을 클릭하시면<br />
                  자동 로그인으로 간편하게 이용하실 수 있습니다.
                </p>
              </div>
              <div className="sign-card__guide-img">
                <img src={app_login_how} alt="카페24 앱 로그인 안내" />
              </div>
              <div className="sign-card__foot">
                <a
                  href={APPSTORE_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="intro-btn intro-btn--primary"
                >
                  카페24 앱스토어로 이동 <FeatherIcon icon="external-link" size="14" />
                </a>
              </div>
            </div>
          ) : (
            <div className="sign-card">
              <div className="sign-card__head">
                <span className="sign-card__chip">
                  <FeatherIcon icon="log-in" size="13" />
                  관리자 로그인
                </span>
                <h1 className="sign-card__title">온리플에 오신 것을 환영합니다</h1>
                <p className="sign-card__desc">
                  쇼핑몰의 상점 아이디와 이메일·비밀번호로 로그인하세요.
                </p>
              </div>

              <form
                className="sign-form"
                onSubmit={(e) => { e.preventDefault(); this.doLogin(); }}
              >
                <div className="sign-form__field">
                  <label htmlFor="platformId">상점 아이디</label>
                  <div className="sign-form__input-wrap">
                    <FeatherIcon icon="shopping-bag" size="15" className="sign-form__input-icon" />
                    <input
                      id="platformId"
                      name="platformId"
                      type="text"
                      autoComplete="username"
                      placeholder="예) onreple"
                      value={this.teamUser.platformId}
                      onChange={this.onChangeValue}
                      onKeyDown={this.handleKeyDown}
                    />
                  </div>
                </div>

                <div className="sign-form__field">
                  <label htmlFor="emailId">이메일 아이디</label>
                  <div className="sign-form__input-wrap">
                    <FeatherIcon icon="mail" size="15" className="sign-form__input-icon" />
                    <input
                      id="emailId"
                      name="emailId"
                      type="text"
                      autoComplete="email"
                      placeholder="example@onreple.co.kr"
                      value={this.teamUser.emailId}
                      onChange={this.onChangeValue}
                      onKeyDown={this.handleKeyDown}
                    />
                  </div>
                </div>

                <div className="sign-form__field">
                  <label htmlFor="password">비밀번호</label>
                  <div className="sign-form__input-wrap">
                    <FeatherIcon icon="lock" size="15" className="sign-form__input-icon" />
                    <input
                      id="password"
                      name="password"
                      type="password"
                      autoComplete="current-password"
                      placeholder="비밀번호를 입력해 주세요"
                      value={this.teamUser.password}
                      onChange={this.onChangeValue}
                      onKeyDown={this.handleKeyDown}
                    />
                  </div>
                </div>

                <div className="sign-form__util">
                  <FormGroup className="m-0">
                    <FormCheckbox
                      toggle
                      small
                      checked={this.isSave}
                      onChange={() => {
                        this.isSave = !this.isSave;
                        Storage.set('isSave', this.isSave);
                      }}
                    >
                      로그인 정보 저장
                    </FormCheckbox>
                  </FormGroup>
                </div>

                <button type="submit" className="sign-form__submit">
                  로그인 <FeatherIcon icon="arrow-right" size="14" />
                </button>
              </form>

              <ul className="sign-card__hints">
                <li>1. 접속 주소는 <code>[상점 아이디].cafe24.com</code> 입니다.</li>
                <li>2. 내 쇼핑몰 정보에서 상점 아이디를 확인할 수 있습니다.</li>
                <li>3. 카페24 관리자에서 온리플 앱을 실행하면 자동 로그인됩니다.</li>
                <li>
                  <span className="sign-card__hint-tag">비밀번호 재설정</span>
                  쇼핑몰 관리자 &gt; 앱 &gt; "온리플" 앱 클릭 시 자동 로그인 후 재설정할 수 있습니다.
                </li>
              </ul>

              <div className="sign-card__foot sign-card__foot--split">
                <span className="sign-card__foot-text">아직 온리플을 사용해 본 적이 없으신가요?</span>
                <Link to="/intro" className="sign-card__foot-link">
                  온리플 둘러보기 <FeatherIcon icon="arrow-right" size="13" />
                </Link>
              </div>
            </div>
          )}

        </div>
      </section>
    );
  }
}

export default SignIn;
